import { FC } from "react";
import { format } from "date-fns";
import {
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import __ from "src/utils/Translations";
import { IExcludedDay } from "src/Pages/Company/Absences/Calendars/Calendars.models";

interface ICalendarLegendProps {
  excludedDays: IExcludedDay[];
}

const CalendarLegend: FC<ICalendarLegendProps> = ({ excludedDays = [] }) => (
  <>
    <Divider
      sx={{
        marginBottom: "2rem",
      }}
    />
    <Table sx={{ minWidth: 500 }} data-testid="absences-calendar-legend">
      <TableHead>
        <TableRow>
          <TableCell
            sx={{
              color: "primary.main",
              borderBottom: "none",
              padding: "0.5rem",
            }}
          >
            {__("Nazwa")}
          </TableCell>
          <TableCell
            sx={{
              color: "primary.main",
              borderBottom: "none",
              padding: "0.5rem",
            }}
          >
            {__("Data")}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {excludedDays.map((day) => (
          <>
            {day.label && (
              <TableRow data-testid="absences-calendar-legend__item">
                <TableCell
                  sx={{
                    borderBottom: "none",
                    padding: "0.5rem",
                  }}
                >
                  {day.label}
                </TableCell>
                <TableCell
                  sx={{
                    borderBottom: "none",
                    padding: "0.5rem",
                  }}
                >
                  {format(new Date(day.date), "dd.MM.yyyy")}
                </TableCell>
              </TableRow>
            )}
          </>
        ))}
      </TableBody>
    </Table>
  </>
);

export default CalendarLegend;
